function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t\t.st0{fill:#FFC801;}\r\n\t\t.st1{opacity:0.5;}\r\n\t\t.st2{fill:url(#SVGID_1_);}\r\n\t\t.st3{fill:#FFFFFF;}\r\n\t\t.st4{filter:url(#Adobe_OpacityMaskFilter);}\r\n\t\t.st5{clip-path:url(#SVGID_3_);fill:url(#SVGID_5_);}\r\n\t\t.st6{opacity:0.6;clip-path:url(#SVGID_3_);mask:url(#SVGID_4_);fill:#FFFFFF;}\r\n\t");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M100.8,86.7c0,7.8-6.4,14.2-14.2,14.2H14.2C6.4,100.8,0,94.5,0,86.7V14.2C0,6.4,6.4,0,14.2,0h72.5 c7.8,0,14.2,6.4,14.2,14.2V86.7z"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M100,85.8c0,7.8-6.4,14.2-14.2,14.2H14.2C6.4,100,0,93.6,0,85.8V14.2C0,6.4,6.4,0,14.2,0h71.7 C93.6,0,100,6.4,100,14.2V85.8z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M49.2,68.7c-11.5,0-17.2-9.3-17.3-17.9c-0.2-8.9,4.9-18.8,17.3-18.8c12.4,0,16.9,9.2,17.3,17.7 c0.1,1.3,0,2.5-0.2,3.8l8,8c1.4-3.7,2-7.6,2-11.5c-0.2-13.6-8.5-27-27.1-27S22,36.7,22,50.5c0.1,13.7,8.4,27.4,27.1,27.4 c3.2,0,6.2-0.4,8.9-1.2l-8-8C49.7,68.7,49.5,68.7,49.2,68.7z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "64.7,60.7 50.4,60.8 71.6,82 86,81.9  "
}));

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_2_",
  d: "M100.8,86.7c0,7.8-6.4,14.2-14.2,14.2H14.2C6.4,100.8,0,94.5,0,86.7V14.2C0,6.4,6.4,0,14.2,0h72.5 c7.8,0,14.2,6.4,14.2,14.2V86.7z"
}));

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter",
  filterUnits: "userSpaceOnUse",
  x: -158.6,
  y: -225.1,
  width: 291.5,
  height: 291.5
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
})));

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "st5",
  cx: -12.9,
  cy: -79.3,
  r: 145.8
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "st6",
  cx: -12.9,
  cy: -79.3,
  r: 145.8
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shield",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.8 100.8",
    style: {
      enableBackground: "new 0 0 100.8 100.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 50,
    y1: 132.2898,
    x2: 50,
    y2: 35.9526
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE3F75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ref4), _ref5, /*#__PURE__*/React.createElement("g", null, _ref6, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_2_",
    style: {
      overflow: "visible"
    }
  })), _ref7, /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -158.6,
    y: -225.1,
    width: 291.5,
    height: 291.5,
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.9216,
    y1: -60.0112,
    x2: 87.4217,
    y2: 35.9888
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ref8)), _ref9));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.f64ea5b2.svg";
export { ForwardRef as ReactComponent };